import { useEffect, useState } from "react";
import labels from "../../utils/labels";
import LabeledSection from "../UI/LabeledSection";
import EmployeeTransportType from "./EmployeeTransportType";
import EmployeeWorktime from "./EmployeeWorkTime";
import { useAppSelector } from "../../store/hooks";

const EmployeeSettingsTab = ({
  onEmployeeUnsavedEdit,
  onDeleteWorkTimeRequest,
}: {
  onEmployeeUnsavedEdit: (hasChanges: boolean) => void;
  onDeleteWorkTimeRequest: () => void;
}) => {
  const [hasWorktimeChanges, setHasWorktimeChanges] = useState(false);
  const [hasTransportChanges, setHasTransportChanges] = useState(false);
  const selectedEmployee = useAppSelector(
    (state) => state.drawerSlice.selectedEmployee!,
  );
  const { manualEdits } = useAppSelector(
    (state) => state.employeeSettingsSlice,
  );

  const manualWorkTimeEdits =
    manualEdits[selectedEmployee.employeeShiftId]?.employeeWorkTime ??
    selectedEmployee.manualShiftChanges?.employeeWorkTime;

  const workTimeToUse =
    manualWorkTimeEdits ?? selectedEmployee.employeeWorkTime;
  const hasWorkTime =
    workTimeToUse.workTimeStart != null && workTimeToUse.workTimeEnd != null;

  useEffect(() => {
    onEmployeeUnsavedEdit(hasWorktimeChanges || hasTransportChanges);
  }, [hasWorktimeChanges, hasTransportChanges, onEmployeeUnsavedEdit]);

  return (
    <>
      {/* daily settings */}
      <LabeledSection title={labels.dailySettings}>
        <EmployeeWorktime
          onUnsavedEdit={setHasWorktimeChanges}
          onDeleteWorkTimeRequest={onDeleteWorkTimeRequest}
        />
        {hasWorkTime && (
          <EmployeeTransportType onUnsavedEdit={setHasTransportChanges} />
        )}
      </LabeledSection>

      {/* permanent settings */}
      {/* <LabeledSection title={labels.permanentSettings}>
        <p>settings...</p>
      </LabeledSection> */}
    </>
  );
};

export default EmployeeSettingsTab;
